import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ReportListLayer from "../../components/Report/ReportListLayer";

const ReportList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Report List" />

        {/* ReportListLayer */}
        <ReportListLayer />
      </MasterLayout>
    </>
  );
};

export default ReportList;
